let contextMenu: HTMLDivElement | null = null;
let activeElement: HTMLElement | null = null;

const copyToClipboard = (text: string): Promise<void> => {
    if (navigator.clipboard) {
        return navigator.clipboard.writeText(text);
    } else {
        return new Promise((resolve, reject) => {
            try {
                const textArea = document.createElement("textarea");
                textArea.value = text;
                textArea.style.position = "fixed";
                textArea.style.left = "-999999px";
                textArea.style.top = "-999999px";
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                const success = document.execCommand("copy");
                document.body.removeChild(textArea);
                if (success) {
                    resolve();
                } else {
                    reject(new Error("Copy failed"));
                }
            } catch (err) {
                reject(err);
            }
        });
    }
};

const createContextMenu = () => {
    contextMenu = document.createElement("div");
    contextMenu.className = "faq-context-menu";
    contextMenu.style.display = "none";
    contextMenu.style.position = "absolute";
    contextMenu.style.zIndex = "9999";

    const copyButton = document.createElement("button");
    copyButton.className = "faq-context-menu-item";

    copyButton.addEventListener("click", () => {
        if (!activeElement) return;
        const elementId = activeElement.id;
        const baseUrl = window.location.origin + window.location.pathname;
        const fullUrl = `${baseUrl}#${elementId}`;

        copyToClipboard(fullUrl)
            .then(() => {
                const copiedText =
                    activeElement?.getAttribute("data-copied-text") ||
                    activeElement?.closest(".faqs")?.getAttribute("data-copied-text") ||
                    "Kopiert!";
                copyButton.textContent = copiedText;
                copyButton.classList.add("success");

                setTimeout(() => {
                    hideContextMenu();
                }, 1000);
            })
            .catch((err) => {
                console.error("Could not copy text: ", err);
                hideContextMenu();
            });
    });

    contextMenu.appendChild(copyButton);
    document.body.appendChild(contextMenu);
};

const showContextMenu = (x: number, y: number, element: HTMLElement) => {
    if (!contextMenu) {
        createContextMenu();
    }
    if (!contextMenu) return;

    activeElement = element;

    const copyButton = contextMenu.querySelector(".faq-context-menu-item") as HTMLButtonElement;
    if (copyButton) {
        const copyText =
            element.getAttribute("data-copy-text") ||
            element.closest(".faqs")?.getAttribute("data-copy-text") ||
            "Link kopieren";
        copyButton.textContent = copyText;
        copyButton.classList.remove("success");
    }

    contextMenu.style.left = `${x}px`;
    contextMenu.style.top = `${y}px`;
    contextMenu.style.display = "block";
};

const hideContextMenu = () => {
    if (contextMenu) {
        contextMenu.style.display = "none";
    }
    activeElement = null;
};

// Close on click outside, escape, scroll, resize
document.addEventListener("click", (e) => {
    if (contextMenu && !contextMenu.contains(e.target as Node)) {
        hideContextMenu();
    }
});

document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
        hideContextMenu();
    }
});

window.addEventListener("scroll", hideContextMenu, { passive: true });
window.addEventListener("resize", hideContextMenu, { passive: true });

const faqSections = document.querySelectorAll(".faqs");

faqSections.forEach((faqSection) => {
    const faqs = faqSection.querySelectorAll(".faq");
    faqs.forEach((faq) => {
        const question = faq.querySelector(".question") as HTMLElement;
        const answerWrapper = faq.querySelector(".answer-wrapper");
        if (question && answerWrapper) {
            question.addEventListener("click", () => {
                const open = answerWrapper.classList.toggle("open");
                question.classList.toggle("open", open);
                question.blur();
            });

            // Handle right click on the FAQ block (excluding clicking inside answer-wrapper)
            faq.addEventListener("contextmenu", (e: Event) => {
                const mouseEvent = e as MouseEvent;
                if ((mouseEvent.target as HTMLElement).closest(".answer-wrapper")) {
                    return;
                }
                mouseEvent.preventDefault();
                showContextMenu(mouseEvent.pageX, mouseEvent.pageY, faq as HTMLElement);
            });
        }
    });
});

const faqBlockSections = document.querySelectorAll(".faq-section");

faqBlockSections.forEach((section) => {
    const heading = section.querySelector(".faq-heading") as HTMLElement;
    if (heading) {
        heading.addEventListener("contextmenu", (e: Event) => {
            const mouseEvent = e as MouseEvent;
            mouseEvent.preventDefault();
            showContextMenu(mouseEvent.pageX, mouseEvent.pageY, section as HTMLElement);
        });
    }
});

const openFaqFromHash = () => {
    const hash = window.location.hash;
    if (hash && hash.startsWith("#faq-")) {
        const targetElement = document.querySelector(hash) as HTMLElement;
        if (targetElement) {
            const question = targetElement.querySelector(".question") as HTMLElement;
            const answerWrapper = targetElement.querySelector(".answer-wrapper") as HTMLElement;

            if (question && answerWrapper && !answerWrapper.classList.contains("open")) {
                answerWrapper.classList.add("open");
                question.classList.add("open");
            }
        }
    }
};

// Run on load and hash change so the browser's native anchor scrolling lands on an opened FAQ
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", openFaqFromHash);
} else {
    openFaqFromHash();
}

window.addEventListener("hashchange", openFaqFromHash);
